import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { User } from '../api/auth/model/user.interface';
import { AuthApiUserService } from '../api/auth/auth-api-user.service';
import { UninitializedBehaviorSubject } from '../uninitialized-behavior-subject';


@Injectable({ providedIn: 'root' })
export class UserStoreService {

  private user$: Observable<User>;
  private userSubject: UninitializedBehaviorSubject<User>;

  constructor(private authApiUserService: AuthApiUserService) {
  }

  getUser$(): Observable<User> {
    if (!this.user$) {
      this.userSubject = new UninitializedBehaviorSubject<User>();
      this.user$ = this.userSubject.asObservable();

      this.authApiUserService
        .readSelfUser$()
        .subscribe(user => this.userSubject.next(user));
    }

    return this.user$;
  }

  clean(): void {
    this.user$ = null;
  }
}
